import {SET_ADYEN_V2_CHECKOUT} from '../../action-types';

const setAdyenV2CheckoutActionObject = adyenV2Checkout => ({
  type: SET_ADYEN_V2_CHECKOUT,
  adyenV2Checkout,
});

const setAdyenV2Checkout = adyenV2Checkout => (dispatch) => {
  dispatch(setAdyenV2CheckoutActionObject(adyenV2Checkout));
};

export default setAdyenV2Checkout;
